import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14 6.862v2.61a.681.681 0 0 1-.69.67h-.66a.681.681 0 0 1-.69-.67V9H9.643a.679.679 0 0 1-.68-.67v-.66a.679.679 0 0 1 .68-.67h2.32v-.14a1.829 1.829 0 0 0-1.84-1.81h-3.89a.683.683 0 0 1-.69-.68v-.65a.681.681 0 0 1 .69-.67h3.89a3.881 3.881 0 0 1 2.74 1.11A3.776 3.776 0 0 1 14 6.862Zm-4.23 4.09h-3.9a1.829 1.829 0 0 1-1.84-1.81V9h2.32a.681.681 0 0 0 .69-.67v-.66A.681.681 0 0 0 6.353 7h-2.32v-.47a.681.681 0 0 0-.68-.68h-.67a.681.681 0 0 0-.68.68v2.61a3.744 3.744 0 0 0 1.13 2.69 3.908 3.908 0 0 0 2.74 1.12h3.9a.672.672 0 0 0 .68-.67v-.66a.672.672 0 0 0-.68-.668Z';
const draw24px =
  'M16.093,18.038v1.09a1.129,1.129,0,0,1-1.14,1.12H8.463a6.469,6.469,0,0,1-4.57-1.86A6.247,6.247,0,0,1,2,13.9V9.548a1.129,1.129,0,0,1,1.14-1.12h1.11a1.129,1.129,0,0,1,1.14,1.12v.78h3.86a1.146,1.146,0,0,1,1.15,1.13v1.09a1.138,1.138,0,0,1-1.15,1.12H5.393v.23a3.047,3.047,0,0,0,3.07,3.02h6.49A1.129,1.129,0,0,1,16.093,18.038ZM20.1,5.608a6.463,6.463,0,0,0-4.56-1.86H9.053A1.131,1.131,0,0,0,7.9,4.868v1.09a1.14,1.14,0,0,0,1.15,1.13h6.49A3.037,3.037,0,0,1,18.6,10.1v.23h-3.86a1.137,1.137,0,0,0-1.14,1.13v1.09a1.129,1.129,0,0,0,1.14,1.12H18.6v.78a1.129,1.129,0,0,0,1.14,1.12h1.11A1.138,1.138,0,0,0,22,14.448V10.1A6.217,6.217,0,0,0,20.1,5.608Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LogoTradeTappIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'logoTradeTapp')) as IconWithRender;

LogoTradeTappIcon.displayName = 'LogoTradeTappIcon';
LogoTradeTappIcon.propTypes = Icon.propTypes;
LogoTradeTappIcon.renderIcon = (props) => <LogoTradeTappIcon {...props} />;
export default LogoTradeTappIcon;
